// extracted by mini-css-extract-plugin
export default {"wrapper":"l_yBqs","banner":"Y7md1T","title":"Dn1jbW","description":"FA9wk1","button":"ugtyL_","searchFadeIn":"idZCkT"};